export const METERS_PER_KM2 = 1000000;
export const YARDS_PER_MILE = 1760;
export const YARDS_PER_MILE2 = 3097594.45;

export const identity = x => x;

export const kilometers = meters => meters / 1000;

export const feet = meters => meters * 3.28084;

export const yards = meters => meters / 0.9144;

export const miles = meters => meters / 1609.34;

export const nauticalMiles = meters => meters / 1852;

export const squareKilometers = meters2 => meters2 / METERS_PER_KM2;

export const hectares = meters2 => meters2 / 10000;

export const squareFeet = meters2 => meters2 * 10.764;

export const squareYards = meters2 => meters2 * 1.19599;

export const squareMiles = meters2 => meters2 / 2.59e6;

export const acres = meters2 => meters2 * 0.00024711;

export const squareNauticalMiles = meters2 => meters2 / 3.43e6;
